import styled from "styled-components";

export const FooterContainer = styled.footer`
	width: 100%;
	padding: 30px 20px;
	background-color: #2c2c34;
	color: #f5f5fa;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	font-family: 'Segoe UI', sans-serif;
`;

export const TopSection = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
`;

export const SocialMedia = styled.div`
	display: flex;
	gap: 20px;
`;

export const SocialMediaIcon = styled.img`
	width: 24px;
	height: 24px;
	cursor: pointer;
	transition: transform 0.2s ease, opacity 0.2s ease;

	&:hover {
		transform: scale(1.2);
		opacity: 0.8;
	}
`;

export const DeveloperSocialMediaIcon = styled.img`
	width: 18px;
	height: 18px;
	cursor: pointer;
	transition: transform 0.2s ease, opacity 0.2s ease;

	&:hover {
		transform: scale(1.2);
		opacity: 0.8;
	}
`;

export const BottomSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	text-align: center;
`;

export const FooterInformation = styled.span`
	font-size: 14px;

	a {
		color: #f5f5fa;
		text-decoration: underline;
	}
`;

export const FooterDeveloperInformation = styled.span`
	font-size: 12px;
	opacity: 0.8;
    border-top: 1px solid #444;
    padding-top: 10px;
	a {
		color: #f5f5fa;
		text-decoration: underline;
	}
`;
